import * as React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import { noop } from 'lodash';
import { Input, Modal } from 'antd';

import s from './style/GroupEditor.pcss';


export default class GroupEditor extends React.Component {
  static propTypes = {
    group: PropTypes.shape(),
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
  };

  static defaultProps = {
    group: {},
  };

  state = {
    name: this.props.group.id ? this.props.group.name : '',
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.visible && !nextProps.visible) {
      this.setState({ name: '' });
    } else {
      this.setState({ name: nextProps.group.id ? nextProps.group.name : '' });
    }
  }

  changeName = e => this.setState({ name: e.target.value });

  handleSave = () => {
    const { group, onEdit } = this.props;
    const { name } = this.state;
    onEdit(group.id, name);
    this.props.onClose();
  };

  renderTitle = () => {
    const { group } = this.props;
    const { name } = this.state;
    const saveDisabled = !name;
    const onClick = saveDisabled ? noop : this.handleSave;
    return (
      <div className={s.title}>
        <div className={s.titleLabel}>
          {group.id ? `Группа "${group.name}"` : 'Новая группа'}
        </div>
        <div className={s.controls}>
          <div className={s.cancelBtn} onClick={this.props.onClose}>Отменить</div>
          <div
            className={`${s.addBtn} ${saveDisabled ? s.disabled : ''}`}
            onClick={onClick}
          >
            {group.id ? 'Редактировать' : 'Добавить'}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { visible } = this.props;
    const { name } = this.state;
    return (
      <div>
        <Modal
          title={this.renderTitle()}
          footer={null}
          visible={visible}
          closable={false}
          destroyOnClose
          width={'650px'}
          bodyStyle={{
            height: '130px',
          }}
          getContainer={() => ReactDOM.findDOMNode(this)}
        >
          <div className={s.inputContainer}>
            <div className={s.inputLabel}>Имя группы</div>
            <Input
              placeholder="Название..."
              value={name}
              onChange={this.changeName}
            />
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Groups/GroupList/GroupEditor.js